import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Container,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useTheme,
  //useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { MainLogo } from "../logo";

const navLinks = [
  { name: "Sobre", to: "/about" },
  { name: "Serviços", to: "/services" },
  { name: "Carreira", to: "/careers" }, 
];
const ctaLink = { name: "Fale connosco", to: "/fale-conosco" };

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  //const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  // Drawer component for mobile view
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center", p: 2 }}>
      <NavLink to="/" style={{ textDecoration: "none" }}>
        <MainLogo />
      </NavLink>
      <List>
        {navLinks.map((link) => (
          <ListItem key={link.name} disablePadding>
            <ListItemButton
              component={NavLink}
              to={link.to}
              sx={{ textAlign: "center" }}
            >
              <ListItemText primary={link.name} />
            </ListItemButton>
          </ListItem>
        ))}
        {/* CTA in mobile menu */}
        <ListItem disablePadding>
          <ListItemButton
            component={NavLink}
            to={ctaLink.to}
            sx={{ textAlign: "center" }}
          >
            <ListItemText primary={ctaLink.name} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <>
      <AppBar
        position="sticky"
        component="header"
        elevation={2}
        sx={{
          backgroundColor: "white",
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
            {/* Logo */}
            <Box
              component={NavLink}
              to="/"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <MainLogo />
            </Box>

            {/* Desktop Navigation */}
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                gap: 2,
              }}
            >
              {navLinks.map((link) => (
                <Button
                  key={link.name}
                  component={NavLink}
                  to={link.to}
                  sx={{
                    color: "text.primary",
                    fontWeight: 600,
                    fontSize: "1rem",
                    "&:hover": {
                      color: "primary.main",
                      backgroundColor: "transparent",
                    },
                    "&.active": {
                      // Style for active NavLink
                      color: "primary.main",
                      textDecoration: "underline",
                      textUnderlineOffset: "6px",
                    },
                  }}
                >
                  {link.name}
                </Button>
              ))}
              <Button
                component={NavLink}
                to={ctaLink.to}
                variant="contained"
                disableElevation
                sx={{ ml: 2 }}
              >
                {ctaLink.name}
              </Button>
            </Box>

            {/* Mobile Navigation Toggle */}
            <IconButton
              color="inherit"
              aria-label="open navigation menu"
              edge="end"
              onClick={handleDrawerToggle}
              sx={{ display: { md: "none" }, color: "primary.main" }}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Mobile Drawer */}
      <Box component="nav">
    
        <Drawer
          variant="temporary"
          anchor="right"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: 240,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </>
  );
}
